import { List, Record } from 'immutable';
import { RoomTypeRateSummary } from './room-type-rate-summary';
import { StaySummary } from 'app/event/models/stay-summary';

const RoomStaySummaryRecord = Record({
  roomTypeRateSummaryList: null,
  staySummary: null
});

export class RoomStaySummary extends RoomStaySummaryRecord {
  roomTypeRateSummaryList: List<RoomTypeRateSummary>;
  staySummary: StaySummary;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/room-stay-summary.ts